import {RefObject, useEffect, useState} from "react";

/**
 * Reads `data-theme` from the nearest themed ancestor of `ref` and follows later changes to it.
 * Portaled content leaves the themed subtree, so it has to carry the attribute itself:
 * `{...(theme ? {"data-theme": theme} : {})}`.
 */
export const useInheritedTheme = (ref: RefObject<HTMLElement | null>): string | null => {
  const [theme, setTheme] = useState<string | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const themeRoot = el.closest("[data-theme]");
    if (!themeRoot) return;

    setTheme(themeRoot.getAttribute("data-theme"));
    const observer = new MutationObserver(() => {
      setTheme(themeRoot.getAttribute("data-theme"));
    });
    observer.observe(themeRoot, {attributes: true, attributeFilter: ["data-theme"]});
    return () => observer.disconnect();
  }, [ref]);

  return theme;
};
